import { Component, OnDestroy } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { BehaviorSubject, Observable, Subscription, of } from 'rxjs';
import { catchError, switchMap, distinctUntilChanged } from 'rxjs/operators';
import { Timestamp } from 'firebase/firestore';
import { NavigationExtras, Router } from '@angular/router';
import { NotificationResponse } from './notifications.types';
import { NotificationDataService } from 'src/app/core/notifications/notification-data.service';
import { CommonModule, NgFor, NgIf } from '@angular/common';
import { DialogModule } from 'primeng/dialog';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { FormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { InputSwitchModule } from 'primeng/inputswitch';
import { TooltipModule } from 'primeng/tooltip';
import { ButtonModule } from 'primeng/button';
import { UserSharedService } from 'src/app/core/users/user.service';

@Component({
    selector: 'app-user-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss'],
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        DropdownModule,
        InputSwitchModule,
        TooltipModule,
        ButtonModule,
    ],
})
export class NotificationsComponent implements OnDestroy {
    notifications: NotificationResponse[] = [];
    allNotifications: NotificationResponse[] = [];
    notificationsCount: number = 0;
    userId: string = '';
    onlyShowUnread: boolean = false;
    private notifSub!: Subscription;
    selectedCategory: string | null = null;
    userData!: any;
    userCode!: string;

    categories = [
        { label: 'Classrooms', value: 'Classrooms' },
        { label: 'Attendance', value: 'Attendance' },
        { label: 'Events & To Dos', value: 'Events & To Dos' },
        { label: 'Student', value: 'Student' },
        { label: 'Staff', value: 'Staff' },
        { label: 'Scheduling', value: 'Scheduling' },
        { label: 'Activities', value: 'Activities' },
        { label: 'Availability', value: 'Availability' },
        { label: 'Communication', value: 'Communication' },
        { label: 'Billing', value: 'Billing' },
        { label: 'Settings', value: 'Settings' },
    ];

    constructor(
        private config: DynamicDialogConfig,
        private _userService: UserSharedService,
        private ref: DynamicDialogRef,
        private router: Router,
        private notificationDataService: NotificationDataService
    ) {}
    closeDialog() {
        this.ref.close();
    }
    ngOnInit(): void {
        // const userCode = localStorage.getItem('userCode');

        this.userCode =
            this._userService.userCode +
            '__' +
            this._userService.selectedSchoolCode;

        this.notificationDataService
            .getNotifications(this.userCode)
            .subscribe((data) => {
                this.allNotifications = data.map((notif: any) => ({
                    ...notif,
                    createdAt: notif.createdAt?.seconds
                        ? new Date(notif.createdAt.seconds * 1000)
                        : new Date(), // fallback
                }));

                console.log('notificationn data', this.allNotifications);
                this.applyFilters();
            });
    }

    applyFilters(): void {
        this.notifications = this.allNotifications.filter((notif) => {
            const categoryMatch = this.selectedCategory
                ? notif.title === this.selectedCategory
                : true;
            const unreadMatch = this.onlyShowUnread ? !notif.read : true;
            return categoryMatch && unreadMatch;
        });
    }

    onCategoryChange(event: any): void {
        this.applyFilters();
    }

    convertTimestampToDate(input: any): Date | null {
        if (!input) return null;

        if (input.seconds) {
            return new Date(input.seconds * 1000);
        }

        if (typeof input === 'string') {
            const date = new Date(input);
            return isNaN(date.getTime()) ? null : date;
        }

        if (input instanceof Date) {
            return input;
        }

        return null;
    }

    markAllAsRead(): void {
        const unreadNotifications = this.notifications.filter((n) => !n.read);

        unreadNotifications.forEach((notif) => {
            this.markAsRead(notif);
        });
    }

    markAsRead(notif: NotificationResponse, event?: Event): void {
        if (event) {
            event.stopPropagation();
        }

        if (!notif.read) {
            notif.read = true; // Optimistically mark as read in UI

            this.notificationDataService
                .markAsRead(this.userCode, notif.id)
                .then(() => {
                    this.applyFilters(); // Optional: re-filter if needed
                })
                .catch((err) => {
                    console.error('Error marking notification as read:', err);
                });
        }
    }

    /**
     * Redirects to a specific page based on action URL format 'module:name:code'
     *
     * @param actionUrl The action URL in the format 'module:name:code'
     */
    redirectToPage(actionUrl: string): void {
        if (!actionUrl) {
            console.warn('No action URL provided');
            return;
        }

        try {
            // Split the action URL by colon
            const parts = actionUrl.split(':');

            if (parts.length < 1) {
                console.error('Invalid action URL format');
                return;
            }

            // Extract the module, name, and code
            const module = parts[0]?.trim().toLowerCase();
            const name = parts.length > 1 ? parts[1]?.trim() : null;
            const code = parts.length > 2 ? parts[2]?.trim() : null;

            // Prepare navigation extras for passing parameters
            const navigationExtras: NavigationExtras = {
                queryParams: {},
            };

            // Ensure queryParams is always an object
            if (!navigationExtras.queryParams) {
                navigationExtras.queryParams = {};
            }

            // Add name and code to query params if they exist
            if (name) {
                navigationExtras.queryParams['name'] = name;
            }

            if (code) {
                navigationExtras.queryParams['nofiyId'] = code;
            }

            // Navigate based on the module
            switch (module) {
                case 'products':
                        this.router.navigate(['/products/product-list'], navigationExtras);
                    break;

                case 'classrooms':
                    
                        this.router.navigate(['/classrooms'], navigationExtras);
                    
                    break;

                case 'staff':
                case 'user':
                    
                        this.router.navigate(['/users'], navigationExtras);
                    
                    break;

                case 'vendors':
                    
                        this.router.navigate(['/vendors/vendor-list'], navigationExtras);
                    
                    break;

                case 'request':
                    
                        this.router.navigate(['/requests'], navigationExtras);
                    
                    break;

                case 'purchase':
                    
                        this.router.navigate(['/purchase'], navigationExtras);
                  
                    break;

                case 'stock':
                    
                        this.router.navigate(['/stocks'], navigationExtras);
                  
                    break;

                case 'settings':
                    this.router.navigate(['/settings'], navigationExtras);
                    break;

                case 'category':
                    this.router.navigate(
                        ['/product-categories'],
                        navigationExtras
                    );
                    break;

                case 'vendorcategory':
                    this.router.navigate(
                        ['/vendor-categories'],
                        navigationExtras
                    );
                    break;

                default:
                    console.warn(`Unknown module: ${module}`);
                    // Default fallback if module is unknown
                    this.router.navigate(['/dashboard']);
                    break;
            }

             this.ref.close();

            console.log(
                `Navigating to module: ${module}, name: ${name}, code: ${code}`
            );
        } catch (err) {
            console.error('Error parsing action URL:', err);
            // Fallback to dashboard on error
            this.router.navigate(['/dashboard']);
        }
    }

    getInitials(text: string): string {
        return text
            .split(' ')
            .map((word) => word.charAt(0))
            .join('')
            .substring(0, 2)
            .toUpperCase();
    }

    getTimeAgo(date: Date | null): string {
        if (!date) return 'Unknown';
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const day = date.getDate();
        const month = months[date.getMonth()];
        const hours = date.getHours();
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const ampm = hours >= 12 ? 'PM' : 'AM';
        const hour12 = hours % 12 || 12;
        return `${day} ${month} ${hour12}:${minutes} ${ampm}`;
    }

    // getTagClass(title: string): string {
    //   switch (title) {
    //     case 'Email Subject SP':
    //       return 'bg-blue-100 text-blue-800';
    //     case 'Messages':
    //       return 'bg-green-100 text-green-800';
    //     case 'Alerts':
    //       return 'bg-red-100 text-red-800';
    //     default:
    //       return 'bg-gray-100 text-gray-800';
    //   }
    // }

    // +++++++++++++++++++++++++++++

    ngOnDestroy(): void {
        if (this.notifSub) {
            this.notifSub.unsubscribe();
        }
    }

    // getTimeAgo(createdAt: any): string {
    //   if (!createdAt) return 'Just now';

    //   // Handle Firestore Timestamp object
    //   let date: Date;

    //   if (createdAt instanceof Timestamp) {
    //     date = createdAt.toDate();
    //   } else if (typeof createdAt === 'string') {
    //     date = new Date(createdAt);
    //   } else if (createdAt.seconds) {
    //     date = new Date(createdAt.seconds * 1000);
    //   } else {
    //     return 'Just now';
    //   }

    //   const now = new Date();
    //   const diff = Math.floor((now.getTime() - date.getTime()) / 1000);

    //   if (diff < 60) return `${diff} sec ago`;
    //   if (diff < 3600) return `${Math.floor(diff / 60)} mins ago`;
    //   if (diff < 86400) return `${Math.floor(diff / 3600)} hrs ago`;

    //   return date.toLocaleDateString('en-US', {
    //     month: 'short',
    //     day: 'numeric',
    //     hour: '2-digit',
    //     minute: '2-digit',
    //   });
    // }

    getTagClass(title: string): string {
        if (!title) return 'bg-gray-100 text-gray-700';

        const colors = [
            { bg: 'bg-green-100', text: 'text-green-700' },
            { bg: 'bg-blue-100', text: 'text-blue-700' },
            { bg: 'bg-red-100', text: 'text-red-700' },
            { bg: 'bg-yellow-100', text: 'text-yellow-700' },
            { bg: 'bg-purple-100', text: 'text-purple-700' },
            { bg: 'bg-pink-100', text: 'text-pink-700' },
            { bg: 'bg-indigo-100', text: 'text-indigo-700' },
            { bg: 'bg-teal-100', text: 'text-teal-700' },
            { bg: 'bg-orange-100', text: 'text-orange-700' },
            { bg: 'bg-cyan-100', text: 'text-cyan-700' },
            { bg: 'bg-teal-100', text: 'text-teal-700' },
        ];

        const hash = [...title.toLowerCase()].reduce(
            (acc, char) => acc + char.charCodeAt(0),
            0
        );
        const colorIndex = hash % colors.length;
        const color = colors[colorIndex];

        return `${color.bg} ${color.text}`;
    }

    // getInitials(name: string): string {
    //   if (!name) return '';
    //   return name.split(' ').map(word => word[0]?.toUpperCase()).join('').slice(0, 2);
    // }

    // onCategoryChange(event: any): void {
    //   this.selectedCategory = event?.value;
    //   this.applyFilters();
    // }

    // applyFilters(): void {
    //   let filtered = [...this.allNotifications];

    //   if (this.onlyShowUnread) {
    //     filtered = filtered.filter(n => !n?.read);
    //   }

    //   if (this.selectedCategory) {
    //     filtered = filtered.filter(n => n?.title === this.selectedCategory);
    //   }

    //   this.notifications = filtered;
    // }

    // markAsRead(notif: NotificationResponse, event: Event): void {
    //   event.stopPropagation(); // Prevent triggering the whole card click
    //   if (!notif.read) {
    //     this.userNotificationService
    //       .markNotificationAsRead(this.userId, notif.id)
    //       .then(() => {
    //         notif.read = true;
    //       })
    //       .catch((error: any) => {
    //         console.error('Failed to mark notification as read:', error);
    //       });
    //   }
    // }

    // markAllAsRead(): void {
    //   this.userNotificationService.markAllNotificationsAsRead(this.userId)
    //     .then(() => {
    //       this.notifications.forEach(notif => notif.read = true);
    //       this.applyFilters();
    //     })
    //     .catch((error: any) => {
    //       console.error('Error marking all as read:', error);
    //     });
    // }

    // redirectToPage(notif: NotificationResponse): void {
    //   const updateReadPromise = !notif.read
    //     ? this.userNotificationService.markNotificationAsRead(this.userId, notif.id).then(() => {
    //         notif.read = true;
    //       })
    //     : Promise.resolve();

    //   const route = this.getRouteForCategory(notif.title);

    //   updateReadPromise.then(() => {
    //     if (route) {
    //       this.ref.close(); // close notification overlay if applicable
    //       setTimeout(() => {
    //         this.router.navigate([route]);
    //       }, 100);
    //     }
    //   });
    // }

    getRouteForCategory(category: string): string {
        const hasEnrollmentAccess = this.userData?.authorities?.includes(
            'Enrollment (Full Access)'
        );

        switch (category) {
            case 'Classrooms':
                return '/myschool';
            case 'Student':
                return '/myschool/student';
            case 'Attendance':
                return '/student-Sign-In/dailyAttendance';
            case 'Events & To Dos':
                return '/myschool/events';
            case 'Staff':
                return '/staff/overview';
            case 'Scheduling':
                return '/scheduling/classroom-view';
            case 'Activities':
                return '/parentConnection/activities/all';
            case 'Availability':
                return hasEnrollmentAccess
                    ? '/future-enrollment/future-availability'
                    : '';
            case 'Communication':
                return '/parentConnection/newsletter/sentLetter';
            case 'Billing':
                return '/billing/accounting/family';
            case 'Settings':
                return '/settings/school';
            default:
                return '';
        }
    }
}
